import React, { ReactElement } from 'react';
import { ViewStyle } from 'react-native';

import KitCompositeImage from './KitCompositeImage';

//******************************************************************************
// Types
//******************************************************************************

export interface IProps {
  backgroundColor?: string;
  imageUrl?: string;
  size: number;
  style?: ViewStyle;
  testID?: string;
}

export default function KitAppIcon({
  backgroundColor,
  imageUrl,
  size,
  style,
  testID = '',
}: IProps): ReactElement | null {
  return (
    <KitCompositeImage
      size={size}
      backgroundColor={backgroundColor}
      borderRadius={size / 2}
      imageUrl={imageUrl}
      style={style}
      testID={testID}
    />
  );
}
